import {Box, InputLabel, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import {AgeGroup, ClimbingEventGroup} from "../../../models/ClimbingEvent";
import {FC} from "react";
import {useTranslation} from "react-i18next";

type Props = {
    groups: AgeGroup[] | ClimbingEventGroup[],
    setGroup: (id: number) => void,
    selectedId?: number,
    id: string,
    label: string
}

export const SelectGroupsComponent: FC<Props> = ({groups, setGroup, selectedId, id, label}) => {
    const {t} = useTranslation();
    return (
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center"}}>
            <InputLabel id="select-age-group-label">{label}</InputLabel>

            <Select
                sx={{minWidth: "120px"}}
                id={`select-${id}`}
                labelId="select-age-group-label"
                value={selectedId || -1}
                onChange={(e) => setGroup(Number(e.target.value))}
            >
                <MenuItem id={`${id}--1`} value={-1}>{t('results.ageGroup.all')}</MenuItem>
                {groups.map((group) =>
                    <MenuItem id={`${id}-${group.id}`} value={group.id}>{group.name}</MenuItem>
                )}
            </Select>
        </Box>
    )
}